import { ModalSheetContext } from '../lib/ModalSheetContext'
import { useContext } from 'react'

/**
 * @typedef {import('react-modal-sheet').ModalSheetProps} ModalSheetProps
 */

/**
 *
 * @returns {{
 *  openModal: (content: React.ReactNode, props: ModalSheetProps) => void,
 *  closeModal: () => void,
 *  toggleModal: (content: React.ReactNode, props: ModalSheetProps) => void,
 *  isFullScreenOpen: boolean,
 *  id: string | null,
 * }}
 */
export const useModalSheet = () => {
  const ctx = useContext(ModalSheetContext)
  if (!ctx) throw new Error('useModalSheet must be used within ModalSheetProvider')
  return ctx
}
